import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overall-reports-page',
  templateUrl: './overall-reports-page.component.html',
  styleUrls: ['./overall-reports-page.component.scss']
})
export class OverallReportsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
